import { useMemo, useState } from "react";
import { Sheet, type SheetDetent } from "react-modal-sheet";
import "./style.css"
import { X } from "lucide-react";

interface Props{
    children: React.ReactNode
    open: boolean
    hasXClose?: boolean
    initialSnap?: number
    disableDrag?: boolean
    snapPoints?: Array<number>
    detent?: SheetDetent
    setOpen: (open: boolean) => void
} 

export default function BottomSheet({ children, open, snapPoints = [1], detent, disableDrag=false, hasXClose=false, initialSnap=1, setOpen }: Props) {
  const [currentSnap, setCurrentSnap] = useState(initialSnap);

  const isAllOpen = useMemo(() => {
    return currentSnap >= snapPoints.length - 1;
  }, [currentSnap, snapPoints]);

  return (
    <>
      <Sheet initialSnap={initialSnap} detent={detent} disableDrag={disableDrag} isOpen={open} onSnap={(snap) => {  setCurrentSnap(snap); }} snapPoints={snapPoints} onClose={() => setOpen(false)}>
        <Sheet.Container className={(!isAllOpen && !disableDrag ) || (disableDrag && snapPoints.length > 2)  ? "react-modal-sheet-container-border-radius" : ""}>
          {!disableDrag ? (
            <Sheet.Header />
          ) : null}

          <Sheet.Content>
            {hasXClose ? (
              <div style={{ height: 25, width: 25, position: "absolute", right: 10, top: 10, opacity: .3, display: "flex", justifyContent: "center", alignItems: "center", padding: 0, zIndex: 9 }}>
                <X style={{  }} onClick={() => setOpen(false)}/>
              </div>
            ) : null }
            {children}
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={() => setOpen(false)} />
      </Sheet>
    </>
  );
}

